import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Section from "./Section";
import AwardRow from "./AwardRow";
import AcceptAwardWizard from "../AcceptAwardWizard";

class AwardSection extends Component {

  constructor(props) {
    super(props);
    this.state = {wizardVisible: false};
  }

  openAcceptWizard = (award, callback) => {
    this.setState({
      wizardVisible: true,
      award: award
    });
  };

  onWizardClosed = () => {
    // Close the wizard.
    this.setState({wizardVisible: false})
  }

  render() {
    const { awards, t } = this.props;

    var sectionTitle = null
    var showLink = null
    var showSectionLink = null
    var hideSectionLink = null
    var showSectionLinkForMobile = null
    var hideSectionLinkForMobile = null

    if(awards && awards.length > 0){
      sectionTitle = this.props.sectionTitle
      showLink = true
      showSectionLink = t("StockAwards.ShowAwardsLink")
      hideSectionLink = t("StockAwards.HideAwardsLink")
      showSectionLinkForMobile = t("StockAwards.ShowAwardsMobileLink" )
      hideSectionLinkForMobile = t("StockAwards.HideAwardsMobileLink")
    } else {
      sectionTitle = t("StockAwards.NoAwardsMessage")
      showLink = false
    }

    return (
      <Section 
        sectionId={`award_section_${this.props.sectionId}`}
        sectionTitle={sectionTitle}
        showLink={showLink}
        showSectionLink={showSectionLink}
        hideSectionLink={hideSectionLink}
        showSectionLinkForMobile={showSectionLinkForMobile}
        hideSectionLinkForMobile={hideSectionLinkForMobile}
        className={this.props.className || 'award-view'}
        childrenHidden={this.props.hidden}>

        {awards && awards.length > 0 && (
          <div>
            {awards.map((el, index) => {
              return <AwardRow
                rowId={`award_section_${this.props.sectionId}_award_row_${index}`}
                key={`user_award_${index}`}
                award={el}
                onAcceptAward={this.openAcceptWizard}
                onChangePaymentMethod={this.props.onChangePaymentMethod}
                onSelectAwardMenuItem={this.props.onSelectAwardMenuItem}
                taxHide={this.props.taxHide} />;
            })}
          </div>
        )}
        <AcceptAwardWizard
          visible={this.state.wizardVisible}
          award={this.state.award}
          broker={this.props.broker} 
          onWizardClosed={this.onWizardClosed}
        />

      </Section>
    );
  }
}

const mapState = state => ({
  broker: state.employee.broker ? state.employee.broker.name : ''
});

export default connect(mapState)(withTranslation("translations")(AwardSection));
